export default __webpack_public_path__ + "img/profile_photo.f6e9fbfb.svg";